var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    rx: 21,
    fill: "#202434"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0003 18.75V16.5C24.0003 14.8431 22.6571 13.5 21.0003 13.5C19.3434 13.5 18.0003 14.8431 18.0003 16.5V18.75M14.6943 19.764L14.2443 24.564C14.1163 25.9287 14.0524 26.6111 14.2788 27.1382C14.4778 27.6012 14.8264 27.984 15.2688 28.2253C15.7724 28.5 16.4578 28.5 17.8286 28.5H24.172C25.5428 28.5 26.2281 28.5 26.7318 28.2253C27.1742 27.984 27.5228 27.6012 27.7217 27.1382C27.9482 26.6111 27.8842 25.9287 27.7563 24.564L27.3063 19.764C27.1982 18.6115 27.1442 18.0353 26.885 17.5996C26.6568 17.2159 26.3195 16.9088 25.9162 16.7174C25.4583 16.5 24.8795 16.5 23.722 16.5L18.2786 16.5C17.121 16.5 16.5423 16.5 16.0843 16.7174C15.681 16.9088 15.3438 17.2159 15.1155 17.5996C14.8563 18.0353 14.8023 18.6115 14.6943 19.764Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping-bag.1657122974f308ca0833e91a4e408079.svg";
export { ForwardRef as ReactComponent };